/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      email
      name
      lastName
      idNumber
      phone
      address
      role
      avatarUrl
      enrollments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        name
        lastName
        idNumber
        phone
        address
        role
        avatarUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBookOrder = /* GraphQL */ `
  query GetBookOrder($id: ID!) {
    getBookOrder(id: $id) {
      id
      bookID
      customerName
      customerEmail
      idNumber
      bankName
      referenceNumber
      bookTitle
      purchaseType
      amountUSD
      amountBS
      receiptKey
      pdfKey
      category
      status
      orderDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBookOrders = /* GraphQL */ `
  query ListBookOrders(
    $filter: ModelBookOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        bookID
        customerName
        customerEmail
        idNumber
        bankName
        referenceNumber
        bookTitle
        purchaseType
        amountUSD
        amountBS
        receiptKey
        pdfKey
        category
        status
        orderDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserNote = /* GraphQL */ `
  query GetUserNote($id: ID!) {
    getUserNote(id: $id) {
      id
      bookID
      content
      pageNumber
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserNotes = /* GraphQL */ `
  query ListUserNotes(
    $filter: ModelUserNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        bookID
        content
        pageNumber
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEnrollment = /* GraphQL */ `
  query GetEnrollment($id: ID!) {
    getEnrollment(id: $id) {
      id
      userEmail
      courseId
      courseTitle
      amountUSD
      amountBS
      referenceNumber
      bankName
      category
      status
      enrollmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEnrollments = /* GraphQL */ `
  query ListEnrollments(
    $filter: ModelEnrollmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEnrollments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userEmail
        courseId
        courseTitle
        amountUSD
        amountBS
        referenceNumber
        bankName
        category
        status
        enrollmentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentRequest = /* GraphQL */ `
  query GetDocumentRequest($id: ID!) {
    getDocumentRequest(id: $id) {
      id
      customerName
      customerEmail
      idNumber
      phone
      areaLegal
      documentType
      description
      clientFileKey
      receiptKey
      resultUrl
      bankName
      priceUSD
      referenceNumber
      category
      status
      requestDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocumentRequests = /* GraphQL */ `
  query ListDocumentRequests(
    $filter: ModelDocumentRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerName
        customerEmail
        idNumber
        phone
        areaLegal
        documentType
        description
        clientFileKey
        receiptKey
        resultUrl
        bankName
        priceUSD
        referenceNumber
        category
        status
        requestDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      recipientEmail
      title
      message
      type
      isRead
      relatedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recipientEmail
        title
        message
        type
        isRead
        relatedId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        name
        lastName
        idNumber
        phone
        address
        role
        avatarUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userNotesByBookID = /* GraphQL */ `
  query UserNotesByBookID(
    $bookID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userNotesByBookID(
      bookID: $bookID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        bookID
        content
        pageNumber
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const enrollmentsByUserEmail = /* GraphQL */ `
  query EnrollmentsByUserEmail(
    $userEmail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEnrollmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    enrollmentsByUserEmail(
      userEmail: $userEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userEmail
        courseId
        courseTitle
        amountUSD
        amountBS
        referenceNumber
        bankName
        category
        status
        enrollmentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByRecipient = /* GraphQL */ `
  query NotificationsByRecipient(
    $recipientEmail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByRecipient(
      recipientEmail: $recipientEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipientEmail
        title
        message
        type
        isRead
        relatedId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExchangeRate = /* GraphQL */ `
  query GetExchangeRate($id: ID!) {
    getExchangeRate(id: $id) {
      id
      currency
      value
      lastUpdated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listExchangeRates = /* GraphQL */ `
  query ListExchangeRates(
    $filter: ModelExchangeRateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExchangeRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        currency
        value
        lastUpdated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCourse = /* GraphQL */ `
  query GetCourse($id: ID!) {
    getCourse(id: $id) {
      id
      title
      subtitle
      description
      targetAudience
      learningObjectives
      modulesText
      evaluationsText
      duration
      startDate
      priceUSD
      instructor
      thumbnailUrl
      promoVideoUrl
      images
      videos
      category
      status
      lessons {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        subtitle
        description
        targetAudience
        learningObjectives
        modulesText
        evaluationsText
        duration
        startDate
        priceUSD
        instructor
        thumbnailUrl
        promoVideoUrl
        images
        videos
        category
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      courseID
      title
      videoUrl
      duration
      order
      description
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        courseID
        title
        videoUrl
        duration
        order
        description
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lessonsByCourseID = /* GraphQL */ `
  query LessonsByCourseID(
    $courseID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonsByCourseID(
      courseID: $courseID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        title
        videoUrl
        duration
        order
        description
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBook = /* GraphQL */ `
  query GetBook($id: ID!) {
    getBook(id: $id) {
      id
      title
      author
      description
      priceUSD
      pricePhysical
      pricePDF
      priceOnline
      imageKey
      images
      videos
      pdfKey
      hasPhysical
      hasDigital
      hasOnline
      category
      s3FolderName
      imagePrefix
      onlineExtension
      totalPages
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBooks = /* GraphQL */ `
  query ListBooks(
    $filter: ModelBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        author
        description
        priceUSD
        pricePhysical
        pricePDF
        priceOnline
        imageKey
        images
        videos
        pdfKey
        hasPhysical
        hasDigital
        hasOnline
        category
        s3FolderName
        imagePrefix
        onlineExtension
        totalPages
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBannerAd = /* GraphQL */ `
  query GetBannerAd($id: ID!) {
    getBannerAd(id: $id) {
      id
      title
      imageUrl
      targetUrl
      position
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBannerAds = /* GraphQL */ `
  query ListBannerAds(
    $filter: ModelBannerAdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBannerAds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        imageUrl
        targetUrl
        position
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
